import { FabricProviderType } from '@common/Fabric/types';
import { ORCHESTRATION_PROVIDER } from '@common/Fabric/types/orchestration';

import { SQL_PROVIDER } from '../constants/sql';

export enum FabricConnectionCreationRole {
  ClusterAdmin = 'cluster-admin',
  TeamAdmin = 'team-admin',
  All = 'all'
}

export const DEFAULT_EDITION_SUPPORTED_FABRIC_PROVIDERS = Object.values(FabricProviderType);
// TODO: Refactor to use a separate project mapping for projects
export const DEFAULT_EDITION_SUPPORTED_SQL_FABRIC_TYPES = [
  ...Object.values(SQL_PROVIDER),
  ORCHESTRATION_PROVIDER.ProphecyManaged
];
